import {useParams} from 'react-router-dom'
import {TopicList} from '../../../components/Topics/TopicList'

const TopicByWorkspacePage = () => {
  const {workspaceId} = useParams()
  return <TopicList workspaceId={workspaceId} />
}

export {TopicByWorkspacePage}
